import { useLocation, useNavigate } from 'react-router-dom';
import { CalendarDays, FolderOpen } from 'lucide-react';

const TABS = [
  {
    key: 'calendar',
    label: 'Calendar',
    icon: CalendarDays,
    path: '/',
    isActive: (p: string) => p === '/' || p.startsWith('/calendar'),
  },
  {
    key: 'projects',
    label: 'Projects',
    icon: FolderOpen,
    path: '/projects',
    isActive: (p: string) => p.startsWith('/projects'),
  },
];

export default function MobileTabBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="flex shrink-0 border-t"
      style={{
        backgroundColor: 'var(--bg-surface)',
        borderColor: 'var(--border)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {TABS.map((t) => {
        const active = t.isActive(pathname);
        const Icon = t.icon;
        return (
          <button
            key={t.key}
            onClick={() => navigate(t.path)}
            className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 font-ui"
            style={{ color: active ? 'var(--accent)' : 'var(--text-secondary)', minHeight: 56 }}
          >
            <Icon size={20} />
            <span className="text-[10px]" style={{ fontWeight: active ? 600 : 400 }}>
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
